export const getSavedUniversalTableSettings = state =>
  state.universalTable.savedUniversalTableSettings;
